module.exports = __webpack_public_path__ + "img/Mai.87b954bc.jpeg";